module.exports = __webpack_public_path__ + "img/capital_icon.84560f96.png";